import { Component, OnInit, TemplateRef, OnDestroy, ViewChild } from "@angular/core";
import { Subscription, ReplaySubject, BehaviorSubject } from "rxjs";

import { Pagination } from "@shared/Entities/Pagination/Pagination.entity";
import { Usuario } from "@shared/Entities/Usuario/usuario.entity";

import { CanalesAsociarUsuarioService } from "@Canales/Shared/Services/canales-asociar-usuario.service";
import { AsociarUsuarioApp } from "@Canales/Shared/Types/Interfaces/asociar-usuario.interface";
import { TablaUsuarioApp } from "@Canales/Shared/Types/Interfaces/table-usuario-app-model";

export interface Usuarios {
  identificacion: string;
  nombre: string;
  apellido: string;
  userCode: string;
  sources: string;
}

export interface ConsultaUsuarioAppResponse {
  items: Usuario[];
  pagination: Pagination;
}

@Component({
  selector: "app-consultar-usuario",
  templateUrl: "./consultar-usuario.component.html",
  styleUrls: ["./consultar-usuario.component.scss"],
})
export class ConsultarUsuarioComponent implements OnInit, OnDestroy {
  public subscriptions: Subscription[] = [];
  public tableUsuarioApp$ = new BehaviorSubject<TablaUsuarioApp[]>([]);

  public $usuarios: ReplaySubject<AsociarUsuarioApp[]> = new ReplaySubject(1);
  public usuarios: AsociarUsuarioApp[] = [];

  public hasSearched: boolean = false;

  //TABLE DATA
  public selectedUsuarios: AsociarUsuarioApp[] = [];
  public selectedTableUsuarios: TablaUsuarioApp[] = [];
  public columns = [];
  public showForm = true;
  public searchCols: string[] = ["email", "nombres", "apellidos", "creado", "fechaActivacion", "creador"];
  public excelName = "Usuarios Administradores Cliente Corporativo";
  @ViewChild("optionsButtonTemplate", { static: true }) public optionsButtonTemplate: TemplateRef<unknown>;
  @ViewChild("agrupadoresTemplate", { static: true }) public agrupadoresTemplate: TemplateRef<unknown>;

  constructor(private readonly usuarioAppRepository: CanalesAsociarUsuarioService) {}

  public ngOnInit(): void {
    this.columns = [
      {
        name: "Identificación",
        prop: "identificacion",
        selected: true,
        width: 150,
      },
      {
        name: "Nombre",
        prop: "nombre",
        selected: true,
        width: 200,
      },
      {
        name: "Apellido",
        prop: "apellido",
        selected: true,
      },
      {
        name: "Email",
        prop: "email",
        selected: true,
        width: 330,
        cellClass: "pre-line-space",
      },
      {
        name: "Sources",
        prop: "sources",
        selected: true,
        width: 100,
      },
    ];
    this.$usuarios.subscribe((usuarios) => {
      this.usuarios = usuarios;
      this.setUserTableData(usuarios);
    });
  }

  private getUsuarios() {
    this.usuarioAppRepository.consultarUsuarioApp().subscribe((Usuarios: Usuarios[]) => {
      this.$usuarios.next(Usuarios);
    });
  }

  public filterUsuarios(filterParameter: AsociarUsuarioApp): void {
    const identificacion = filterParameter.identificacion;
    const userCode = filterParameter.userCode;

    this.usuarioAppRepository.consultarUsuarioApp(identificacion, userCode).subscribe((response) => {
      this.hasSearched = true;
      this.setUserTableData(response);
    });
  }

  public toggleFilter(): void {
    this.showForm = !this.showForm;
  }

  private setUserTableData(usuariosAPP: AsociarUsuarioApp[]): void {
    const TablaUsuarioAppUser: TablaUsuarioApp[] = usuariosAPP.map((admin) => {
      const agrupadores = admin.sources.split("  ").join(", "); // Reemplaza espacios por comas
      return {
        identificacion: admin.identificacion,
        nombre: admin.nombre, // 'nombre' es ahora un string según la interfaz
        apellido: admin.apellido,
        email: admin.userCode,
        sources: agrupadores,
      };
    });
    this.tableUsuarioApp$.next(TablaUsuarioAppUser);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) subscription.unsubscribe();
    });
  }
}
